import React from 'react';
import PurchaseItem from './PurchaseItem';
import HttpClient from 'services/HttpClient';
import {inject, observer} from 'mobx-react'
import {ClipLoader} from "react-spinners";
import {observe} from 'mobx';
import Pagination from './Pagination';
import Modal from 'react-modal';
import { Link } from "react-router-dom";
import {WORKSHOP_TYPES} from '../../stores/WorkshopsUrlConstants';


const customStyles = {
  content : {
      margin: '0',
      position: 'fixed',
      top: '50%',
      left: '50%',
      width: '100%',
      maxWidth: '500px',
      height: 'fit-content',
      background: 'transparent',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      border: 'none',
      outline: 'none',
      padding: '0',
      transform: 'translate(-50%,-50%)'
  }
};

const PURCHASED_LIST = '/api/v1/workshops/purchased/?page=';
const PURCHASED_LIST_SPONSOR = '/api/v1/workshops/iacp_purchased/?page=';
const PURCHASED_LIST_ACI = '/api/v1/workshops/aci_purchased/?page=';


@inject('purchased', 'user')
@inject('SponsorStore')
export default class PurchasedList extends React.Component {

  state = {items: [], pages: 1, isLoading: false};

  componentWillMount = () => {
    const checkSponsor = this.props.SponsorStore.sponsorId;
    this.props.purchased.setInitialState();
    this.request(checkSponsor);
    this.listener = observe(this.props.purchased, 'currentPage', () => this.request(checkSponsor));
    this.checkPurchase();
  };

  request = (sponsor) => {
    this.setState({isLoading: true});
    let get_url;
    if (sponsor == 'iacp') {
      get_url = PURCHASED_LIST_SPONSOR;
    } else if(sponsor == 'aci') {
     get_url = PURCHASED_LIST_ACI;
    } else {
      get_url = PURCHASED_LIST;
    }

    const workshop_type = this.props.location.search.replace('?workshop_type=', '');
    const request_workshop_type = '';//workshop_type ? `&workshop_type=${WORKSHOP_TYPES[workshop_type]}` : '';
    new HttpClient().get(PURCHASED_LIST + this.props.purchased.currentPage + request_workshop_type).then(data => {
      this.setState({
        ...this.state,
        items: data.body.data.workshops,
        pages: data.body.data.pages,
        isLoading: false,
      });
      this.props.purchased.setTotalPages(data.body.data.pages);
    })
  };

  componentWillUnmount = () => {
    this.listener();
    this.props.purchased.offPurchaseCompleted();
  };

  checkPurchase = () => {
    const { purchaseCompleted, redirectedToPurchase, clearRedirectedToPurchase } = this.props.purchased;
    const purchaseMessageSeen = localStorage.getItem('purchaseMessageSeen');
    if (purchaseCompleted && !purchaseMessageSeen && redirectedToPurchase) {
      localStorage.setItem("purchaseMessageSeen", "true");
      clearRedirectedToPurchase();
      this.setState({
        ...this.state,
        showPurcaseInfo: true
      })
    }
  }

  closeModal = () => {
    this.props.purchased.offPurchaseCompleted();
    this.setState({
      ...this.state,
      showPurcaseInfo: false
    })
  }


  render(){
    return(
      <main className="main-content purchased">
        <div className="container-fluid">
          <div className="dashboard row">
            {this.state.items.map((el,i) => <PurchaseItem data={el} key={i}/> )}
            {this.state.isLoading && (
              <div className="spinner-container">
                <ClipLoader color='#00BFFF' loading={this.state.isLoading} size={150} />
              </div>
            )}
          </div>
          {this.state.pages !== 0 &&
          <Pagination/>
          }
        </div>
        <Modal
          isOpen={this.state.showPurcaseInfo}
          style={customStyles}
          shouldCloseOnOverlayClick={true}
          onRequestClose={this.closeModal}
        >
          <div className="quiz-modal">
            <div className="qm-message">
              <p>Your payment has been processed.</p>
              <p>Please click on the <Link to={ this.props.user.user.role === 'iacp' ? ' /iacp/in_progress' : '/inprogress_workshops'} className='alert-underlined-link'>“In Progress”</Link><span> tab to view the workshop.</span></p>
            </div>
            <div className="qm-close">
              <button onClick={this.closeModal}><i className="ic-close-ico"/></button>
            </div>
          </div>
        </Modal>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/purchased/PurchasedList.jsx